"use client"

import { useEffect } from "react"
import { HttpTypes } from "@medusajs/types"
import { captureAnalyticsEvent } from "@/lib/analytics/posthog-client"

interface ProductViewTrackerProps {
  product: HttpTypes.StoreProduct
  isOutOfStock?: boolean
}

/**
 * Client component to track product page views
 * This component should be placed on product detail pages to track when users view products
 */
export default function ProductViewTracker({
  product,
  isOutOfStock = false,
}: ProductViewTrackerProps) {
  useEffect(() => {
    if (!product?.id) {
      return
    }

    captureAnalyticsEvent("product_viewed", {
      product_id: product.id,
      product_title: product.title,
      product_handle: product.handle,
      collection_id: product.collection_id,
      category_ids: product.categories?.map((category) => category.id) ?? [],
    })

    if (isOutOfStock) {
      captureAnalyticsEvent("product_out_of_stock_viewed", {
        product_id: product.id,
        product_title: product.title,
        product_handle: product.handle,
      })
    }
  }, [isOutOfStock, product])

  // This component doesn't render anything visible
  return null
}
